export const metrics: Metrics = {
    ROI: {
        article: 'an',
        costType: 'currency',
        description:
            'Return on Investment (ROI) is the ratio of profits to costs. In other words, (Revenue - Costs) / Costs.',
        fullName: 'Return on Investment',
        max: {
            bounce: 1.0113591772669304,
            bounceCostOffset: 3.036174027733804,
            closed: 0.3745344506517691,
            closedCostOffset: 1.5232605177993528,
            default: -0.0419921875,
        },
        impactLabel: 'revenue',
        impactType: 'currency',
        goal: 0.3,
        name: 'ROI',
        unit: '%',
    },
    VCR: {
        article: 'a',
        costType: 'currency',
        description: 'Value to Cost Ratio (VCR) is the value generated divided by costs.',
        fullName: 'Value to Cost Ratio',
        max: {
            bounce: 2.0113591772669306,
            bounceCostOffset: 4.036174027733804,
            closed: 1.3745344506517692,
            closedCostOffset: 2.523260517799353,
            default: 0.9580078125,
        },
        impactLabel: 'impact',
        impactType: null,
        goal: 1.3,
        name: 'VCR',
        unit: '',
    },
};

export const metricMaxGates: Record<string, string[]> = {
    bounce: ['1-0', '2-1', '3-2', '4-3', '5-4', '6-5', '7-6', '8-7'],
    bounceCostOffset: ['1-0', '2-1', '3-2', '4-3', '5-4', '6-5', '7-6', '8-7'],
    closed: ['1-0', '3-1', '5-2', '7-3'],
    closedCostOffset: ['1-0', '2-1', '3-2', '5-3', '6-4'],
    default: [],
};

export const general: GeneralSetup = {
    budgetLabel: 'budget',
    costUnit: '',
    counterEase: 0.5,
    counterInterval: 50,
    currency: '$',
    documentDescription:
        'Learn innovation management principles for better ROI. Use stage gates, metered funding, pivots, calculate outcomes, and make data-driven decisions.',
    documentTitle: 'Plinkromatic - Kromatic',
    favicon: '/favicon.png',
    impactLabel: '',
    impactUnit: '',
    metric: metrics.ROI,
    metricName: 'ROI',
    portionMarking: null,
    profitUnit: '',
    siteName: 'Kromatic',
    socialDescription:
        'Play Kromatic’s innovation management game to practice stage gates, metered funding, pivots, and data-driven portfolio decisions.',
    socialImage: '/assets/illustrations/datadriven-decisions.png',
    socialImageAlt: 'A funnel with ideas coming in and money going out',
    socialTitle: 'Plinkromatic | Kromatic',
};
